module.exports = __webpack_public_path__ + "img/pricing-visual.32ec21d9.png";